import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Language toggle — tapping cycles between EL and EN.
 * Shows the CURRENT language as a tiny pill.
 * compact=true (default in top bar): 24px, minimal footprint.
 */
const LanguageToggle = ({ compact = false }) => {
  const { language, toggleLanguage } = useLanguage();

  const label = language === 'el' ? 'ΕΛ' : 'EN';
  const switchTo = language === 'el' ? 'English' : 'Ελληνικά';

  return (
    <Tooltip title={`Switch to ${switchTo}`} placement="bottom">
      <Button
        onClick={toggleLanguage}
        variant="outlined"
        size="small"
        sx={{
          minWidth: 0,
          px: compact ? 1 : 1.5,
          height: compact ? 24 : 32,
          fontSize: compact ? '0.72rem' : '0.85rem',
          fontWeight: 700,
          lineHeight: 1,
          borderColor: 'rgba(61,107,40,0.4)',
          color: '#3d6b28',
          borderRadius: compact ? '6px' : '8px',
          '&:hover': { borderColor: '#3d6b28', bgcolor: '#f0f7f1' },
        }}
        aria-label={`${label} — ${switchTo}`}
      >
        {label}
      </Button>
    </Tooltip>
  );
};

export default LanguageToggle;
